// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import  './components/icons';
import Location from './components/SearchByLocation';
import GetDetailsByName from './components/GetDetailsByName';
import Footer from './components/Footer';
import WorkingProcess from "./components/WorkingProcess";
import Aboutus from './components/Aboutus';
import FAQs from './components/Faqs';
import ContactUs from './components/ConatctUs';
import Listing from './components/Listing';
import Blog from './components/Blog';
import BlogPage from './components/BlogPage';
import Landowners from './components/Landowners';

function App() {
  return (
    <Router>
      <Navbar /> 
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/" element={<WorkingProcess />} /> */}
        <Route path="/:location/:category" element={<Location />} />
        <Route path="/GetDetailsByName" element={<GetDetailsByName/>} />
        <Route path="/Aboutus" element={<Aboutus/>} />
        <Route path="/Listing" element={<Listing/>} />
        <Route path="/FAQs" element={<FAQs/>} />
        <Route path= '/ContactUs' element={<ContactUs />} />
        <Route path= '/Landowners' element={<Landowners />} />
        <Route path= '/Blog' element={<Blog />} />
        <Route path= '/Blog/:title/:id' element={<BlogPage />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
